import React from "react";

const Loader = () => {
  return (
    <div className="preloader">
      <div className="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
